module.exports = __webpack_public_path__ + "static/AvenirNext-Regular-d4e99131379f49207598d695a76440a7.woff2";